import React from 'react';
import classes from './styles.module.css';
import componentsClasses from '@app/styles/components.module.css';
import cls from 'classnames';
import { CircularProgress } from '@material-ui/core';
import { useIsTabletOrMobileScreenSize } from '@app/utils/media-query';
import { ReactNode } from 'react';
import { Delete, DeleteForever, RemoveShoppingCart } from '@material-ui/icons';

type Props = {
  disabled: boolean;
  onClick: () => void;
  isLoading: boolean;
  label: string;
  icon?: ReactNode;
  dataCy?: string;
  dataDisabled?: string;
};

function BaseButton({ disabled, onClick, isLoading, label, icon, dataCy, dataDisabled }: Props) {
  return (
    <div
      className={cls(componentsClasses.successButton, classes.button)}
      style={{ backgroundColor: disabled ? '#ccc' : '#25d366' }}
      onClick={onClick}
      data-cy={dataCy}
      data-disabled={dataDisabled}
    >
      {isLoading ? (
        <CircularProgress style={{ color: '#fff' }} size={15} />
      ) : (
        <>
          <span>{label}</span>
          {icon && icon}
        </>
      )}
    </div>
  );
}

type WhatsappButtonProps = Omit<Props, 'icon' | 'label'> & {
  onlyRegisterOrder: boolean;
};

export function WhatsappButton(props: WhatsappButtonProps) {
  const isMobile = useIsTabletOrMobileScreenSize();

  function label() {
    if (props.onlyRegisterOrder) return 'REGISTRAR PEDIDO';
    return isMobile ? 'CONCLUIR COM WHATSAPP' : 'CONCLUIR COM WHATSAPP WEB';
  }

  function icon() {
    if (props.onlyRegisterOrder) return null;
    return <div className={classes.whatsappIcon} />;
  }

  return (
    <BaseButton
      dataCy="whatsapp-button"
      dataDisabled={props.disabled ? 'true' : 'false'}
      label={label()}
      icon={icon()}
      {...props}
    />
  );
}

type ClearButtonProps = Omit<Props, 'icon' | 'label' | 'isLoading'>;

export function ClearButton(props: ClearButtonProps) {
  return (
    <BaseButton
      label="LIMPAR"
      icon={<DeleteForever style={{ color: '#fff', fontSize: 23, marginLeft: 5 }} />}
      isLoading={false}
      {...props}
    />
  );
}
